import React, { useReducer, useEffect, useContext, useCallback } from 'react'
import './TemplateRestaurante.scss'
import Header from './restaurante/Header'
import Sidebar from './restaurante/Sidebar'
import { GlobalContext } from 'globalContext'
import history from 'services/history'
import jwt from 'jsonwebtoken'
import Footer from './restaurante/Footer'

function reducer(state, action) {
    switch (action.type) {
        case 'setSidebarVisible':
            return { ...state, sidebarVisible: action.payload }
        default:
            return state
    }
}

export default function Template(props) {

    const { location } = props

    const [state, dispatch] = useReducer(reducer, { sidebarVisible: false })
    const [global, setGlobal] = useContext(GlobalContext)

    const toogleSidebar = useCallback(function (value) {
        dispatch({ type: 'setSidebarVisible', payload: value })
    }, [])

    useEffect(() => {
        if (state.sidebarVisible === true)
            setTimeout(() => toogleSidebar(false), 300)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    // useEffect(() => {
    //     localStorage.removeItem('JWTR');
    //     setGlobal({
    //         type: 'reset'
    //     });
    //     history.push('/restaurante')
    // }, [])

    useEffect(() => {
        let token = localStorage.getItem('JWTR')
        if (!token) {
            history.replace('/restaurante')
        } else {
            const now = Date.now() / 1000
            if (now > token.exp)
                history.replace('/restaurante')
            else
                setGlobal({
                    type: 'setUserRest',
                    payload: jwt.decode(token)
                })
        }
    }, [setGlobal])

    const headerProps = { toogleSidebar, sidebarVisible: state.sidebarVisible }

    return (
        <div id='template-restaurante' className='d-flex flex-column flex-grow-1'>
            {global.userRest !== null &&
                <>
                    <Header {...headerProps} />
                    <Sidebar {...headerProps} />
                    <Footer />
                </>
            }
            <div className="wrapper d-flex flex-grow-1 flex-column">
                {props.children}
            </div>
        </div>
    )
}
